module.exports = __webpack_public_path__ + "img/D201705_2.27beec86.jpg";